import { render } from "./GoToTopButton.vue?vue&type=template&id=7ee7ea7a&scoped=true"
import script from "./GoToTopButton.vue?vue&type=script&lang=js"
export * from "./GoToTopButton.vue?vue&type=script&lang=js"

import "./GoToTopButton.vue?vue&type=style&index=0&id=7ee7ea7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee7ea7a"]])

export default __exports__